import * as React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import InboxIcon from "@mui/icons-material/Inbox";
import DraftsIcon from "@mui/icons-material/Drafts";

export const MenuCustom = ({ menuItems, setSelectedIndex, selectedIndex, data }: any) => {

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index);
  };

  return (
    <Box sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
      <List component="nav" aria-label="main mailbox folders">
        {menuItems?.map((iteam: any) => {
          return (
            <ListItemButton
              selected={selectedIndex === iteam.key}
              onClick={(event) => handleListItemClick(event, iteam?.key)}
            >
              <ListItemIcon>
               {iteam?.icon}
              </ListItemIcon>
              <ListItemText primary={iteam?.title} />
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );
};
